/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass, FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClassFromJSONTyped, FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClassToJSON, } from './FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass';
export function FxIdWebFeaturesAuthAuthenticateFromGameResponseNotConnectedDataFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromGameResponseNotConnectedDataFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromGameResponseNotConnectedDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass(json)) {
        return FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClassFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesAuthAuthenticateFromGameResponseNotConnectedDataToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromGameResponseNotConnectedDataToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromGameResponseNotConnectedDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClass(value)) {
        return FxIdWebFeaturesAuthAuthenticateFromGameNotConnectedDataClassToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromGameResponseNotConnectedData.js.map